import type { FaireProductEntity } from "../../entity_types/product";

export const p_wrxqwgya3z: FaireProductEntity = {
  token: "p_wrxqwgya3z",
  type: "product",
  name: "Chili Nut Crunch Original - 1 Case (12 Jars)",
  brandToken: "b_baevxea2c8",
  brandName: "Wattana",
  imageUrl:
    "https://cdn.faire.com/fastly/395fbb757201d6f0d7043dc3cf58dc89ba822d3c62c7373d3b4e3e20031f4882.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/587fed44dde333a2e0814d5cebb02d9b32791fcd9f64b17eb7b7e595255d24af.jpeg",
    "https://cdn.faire.com/fastly/fce4bc71a0ce28e351999c6a0aa462f568e3908c9d49162b42e91e2114567964.jpeg",
    "https://cdn.faire.com/fastly/7b15acee272f3bbc4ecb4b7382f8409582633c8380773a372d7d996b796a4346.jpeg",
    "https://cdn.faire.com/fastly/3acc13de483ec44173f0770b97bb6308cd6ff671c2f7f04674598a5009aef372.jpeg",
    "https://cdn.faire.com/fastly/703be4ef6970d0c5d86d399e0c884db83814ca9da65fcd731e389d8c6d52b774.jpeg",
    "https://cdn.faire.com/fastly/f6903d1a49be08970682f7f75a2ad2cd9a9a092db21688d8e181809950763cb8.jpeg",
    "https://cdn.faire.com/fastly/40088324d87f70ff7bf0aeb78e799610633e99308773160442d96b8408d06fa1.jpeg",
    "https://cdn.faire.com/fastly/5e9b51f3439a3d523a715d6497d4c2dac71b7f90e3b457a095e552d1b69c8c86.jpeg",
    "https://cdn.faire.com/fastly/9f7bd85037a1588e08648efeec24f506a61d5a749a9676c7dcf8c3ee55effdf6.jpeg",
    "https://cdn.faire.com/fastly/dcd478e54d822a075f31203a4f3f2a5f5dbd5ab0699109a8e39bac1f203df786.jpeg",
  ],
  priceDollars: 144,
  description:
    "Wattana Chili Nut Crunch -Original- Mild Heat \nA bestselling Thai chili oil, packed with crispy garlic, crispy shallots, roasted cashews, and soft, balanced heat. Made in Thailand with organic ingredients, this vegan-friendly condiment delivers rich umami flavor and craveable crunch—perfect for noodles, rice, eggs, pizza, and more.\n\nThis robust 12-pack includes individually honeycomb-wrapped jars for safe shipping and shelf-ready display. With vibrant packaging and clean ingredients, it appeals to foodies, health-conscious shoppers, and chili lovers alike.\n\nKey Features:\n• 12 retail-ready jars\n• Organic, vegan, no preservatives or MSG\n• Small-batch, shelf-stable\n• Low to mild heat, bold flavor\n\nGreat for: \n• Specialty grocers\n• Gourmet shops\n• Gift stores\n\nJar Size: 8.8oz \nMSRP: $24/jar \nCase Pack: 12 jars",
  tags: [],
  msrpDollars: 288,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:22.687Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
